<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import { useAlert } from 'dashboard/composables';
import { useSalesReceipt } from '../composables/useSalesReceipt';
import SalesDetailFactList from './SalesDetailFactList.vue';

const props = defineProps({
  loading: { type: Boolean, default: false },
  transaction: { type: Object, default: null },
});

const { t } = useI18n();
const transactionId = computed(() => props.transaction?.id);
const receipt = computed(() => props.transaction?.receipt || null);
const state = useSalesReceipt({
  id: transactionId,
  t,
  notify: useAlert,
  receipt,
});

const receiptItems = computed(() => [
  {
    key: 'type',
    label: t('SALES.DETAIL.RECEIPT.TYPE'),
    value: state.data.value?.signature_type,
  },
  {
    key: 'date',
    label: t('SALES.DETAIL.RECEIPT.SIGNATURE_DATE'),
    value: state.data.value?.signature_date,
  },
]);
</script>

<template>
  <div v-if="loading" class="h-40 animate-pulse rounded-lais bg-white" />
  <LaisCard
    v-else
    :title="t('SALES.DETAIL.RECEIPT.TITLE')"
    prefix-icon="i-lucide-file-signature"
  >
    <div class="grid gap-4">
      <SalesDetailFactList :items="receiptItems" />

      <div
        v-if="state.document.value"
        class="flex flex-wrap items-center justify-between gap-3 rounded-lais-sm bg-lais-bg-soft p-4"
      >
        <div class="min-w-0">
          <p class="truncate text-sm font-semibold text-lais-text">
            {{ state.document.value.filename }}
          </p>
          <p class="mt-1 text-xs text-lais-text-muted">
            {{ state.document.value.content_type }}
          </p>
        </div>
        <LaisPrimaryButton
          v-if="state.document.value.download_available"
          size="sm"
          variant="ghost"
          icon="i-lucide-download"
          @click="state.download"
        >
          {{ t('SALES.DETAIL.RECEIPT.DOWNLOAD') }}
        </LaisPrimaryButton>
      </div>
      <p v-else class="text-sm text-lais-text-muted">
        {{ t('SALES.DETAIL.RECEIPT.NO_FILE') }}
      </p>
    </div>
  </LaisCard>
</template>
